import { props, state } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import loadOrderHistory from './loadOrderHistory'

export default [
  set(state`orderHistory.skip`, 0),
  set(state`orderHistory.assignedTo`, null),
  set(state`orderHistory.statuses`, ['UNDER_ATTEST']),
  set(props`onlyAttest`, true),
  ...loadOrderHistory
]



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/chains/loadAttestOrders.js